<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import CopyCode from './CopyCode.svelte';
  import RewardCoin from './RewardCoin.svelte';
  import Text from '../typography/Text.svelte';
  import { AppState } from '../../etc/stores';
  import Analytics from '../../services/analytics';
  import flagKeys from '../../etc/flagKeys';
  import ExpiringCountdown from '../expiring-countdown/ExpiringCountdown.svelte';

  const dispatch = createEventDispatcher();

  type PaymentCodeProps = {
    id: string;
    formattedMoneyAmount?: string;
    moneyValue: number;
    code: string;
    status: string;
    type?: string;
    initiative?: string;
    expiresAt?: string;
  };

  export let data: PaymentCodeProps;
  export let disabled: boolean = false;

  $: expirableCoinsIsActive = $AppState.featureFlags.includes(flagKeys.EXPIRABLE_COINS);

  const getCouponTag = () => {
    if (data.initiative === 'free-coins') {
      return 'Welcome Coins';
    }

    if (data.initiative === 'referral-program') {
      return 'Referral';
    }

    return 'Converted Coins';
  };

  const onCopy = () => {
    Analytics.logEvent('click-copy-code', 'logged-in-state');
  };

  $: value = data.formattedMoneyAmount
    ? data.formattedMoneyAmount
    : data.moneyValue / 100;

  $: isPercentage = value && String(value).includes('%');
</script>

<div class="twism-payment-code-item" class:--disabled={disabled}>
  <RewardCoin
    size="112"
    value={data.moneyValue / 100}
    type={isPercentage ? 'percentage' : 'default'}
  />
  <div class="twism-payment-code-item__content">
    <div class="twism-payment-code-item__tag">
      <p>{getCouponTag()}</p>
    </div>
    <CopyCode
      class="twism-payment-code-item__code-container"
      code={data.code}
      on:copy={onCopy}
      {disabled}
    >
      <Text
        class="twism-payment-code-item__code"
        type="medium"
        bold
        color={$AppState.theme.colors.primary200}
      >
        {data.code}
      </Text>
    </CopyCode>
    {#if expirableCoinsIsActive && data?.expiresAt && data?.status === 'active'}
    <ExpiringCountdown expiresAt={data.expiresAt} on:expired={() => dispatch('expired', data.id)} />
    {/if}
  </div>
</div>

<style lang="scss">
  .twism-payment-code-item {
    display: flex;
    align-items: center;

    :global(.twism-copy-code__content) {
      width: auto;
    }

    :global(.twism-copy-code__content > svg) {
      position: relative;
      right: 0;
      top: 0;
      margin-left: 16px;
    }

    &.--disabled {
      opacity: 0.3;
      pointer-events: none;

      :global(.twism-copy-code) {
        opacity: 1;
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding-left: 16px;
      width: 100%;
    }

    &__tag {
      padding: 0 4px;
      background: #dcf8e9;
      border-radius: 4px;
      align-self: flex-start;
      width: fit-content;

      p {
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #1ea961;
        text-transform: uppercase;
      }
    }
  }
</style>
